"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastFiscalYearRange = exports.fiscalYearRange = void 0;
var moment_1 = __importDefault(require("moment"));
function fiscalYearRange() {
    return {
        start: moment_1.default().date(1).month(3) < moment_1.default()
            ? moment_1.default().date(1).month(3).startOf('day').toDate()
            : moment_1.default().date(1).month(3).subtract(1, 'year').startOf('day').toDate(),
        end: moment_1.default().date(1).month(3) < moment_1.default()
            ? moment_1.default().date(1).month(3).subtract(1, 'day').add(1, 'year').endOf('month').toDate()
            : moment_1.default().date(1).month(3).subtract(1, 'day').endOf('month').toDate(),
    };
}
exports.fiscalYearRange = fiscalYearRange;
function lastFiscalYearRange() {
    return {
        start: moment_1.default().date(1).month(3) < moment_1.default()
            ? moment_1.default().date(1).month(3).subtract(1, 'year').startOf('day').toDate()
            : moment_1.default().date(1).month(3).subtract(2, 'year').startOf('day').toDate(),
        end: moment_1.default().date(1).month(3) < moment_1.default()
            ? moment_1.default().date(1).month(3).subtract(1, 'day').endOf('month').toDate()
            : moment_1.default().date(1).month(3).subtract(1, 'day').subtract(1, 'year').endOf('month').toDate(),
    };
}
exports.lastFiscalYearRange = lastFiscalYearRange;
//# sourceMappingURL=fiscalYearRange.js.map